import React from 'react'
import { Separator } from '../separator'

interface AdditionalAlertProps extends React.HTMLProps<HTMLDivElement>{
  titleContent?: string | JSX.Element;
  descriptionContent?: string | JSX.Element; 
  icon?:JSX.Element
}

function AdditionalAlert({...props}:AdditionalAlertProps) {
  return (
    <div className={`d-flex align-items-center polymer-alert border-0 ${props.className}`} style={{...props.style}}>
      <div className='d-flex flex-column flex-fill'>
        {typeof props.titleContent == "string" && 
          <>
            <div className='d-flex polymer-alert__title'>
              {props.icon}
              <h2 style={{flex:1, margin:"auto",textAlign:"left", fontSize:"1.125rem"}}>{props.titleContent}</h2>
            </div>
            <Separator style={{margin: "0.6rem 0"}}/>
          </>
        }
        {typeof props.titleContent == "object" && <div className='d-flex polymer-alert__title'>
          {props.titleContent}
        </div>}
        {typeof props.descriptionContent == "string" &&  <div className='polymer-alert__content'>
          <p className="mb-0" style={{fontSize: "1rem"}}>{props.descriptionContent}</p>
        </div>}
        {typeof props.descriptionContent == "object" &&  <div className='polymer-alert__content'>
          {props.descriptionContent}
        </div>}
      </div>
    </div>
  )
}

export default AdditionalAlert
